"use client";

import { AdvertisementBlockType, PageAdBlocksTypes } from "@/types/page";
import AdBanner from "../GoogleAdSense/AdBanner";
import { AdTypeEnum } from "@/types/common";

export default function AdvertisementBlock({
  block,
  advertisementData,
}: {
  block: AdvertisementBlockType;
  advertisementData?: PageAdBlocksTypes;
}) {
  return (
    <div className="flex justify-center">
      <div
        className={
          "" +
          (block?.adType === "vertical"
            ? "w-full min-h-[550px] max-h-[750px] hidden lg:block"
            : block?.adType === "horizontal"
            ? "w-full h-full"
            : "w-full max-w-[350px] aspect-square")
        }
      >
        <div className="w-full h-full ">
          {process.env.NEXT_PUBLIC_ENABLE_ADS === "true" ? (
            advertisementData?.adType === AdTypeEnum.DAILYHUNT ||
            advertisementData?.adType === AdTypeEnum.GOOGLE ||
            advertisementData?.adType === AdTypeEnum.CUSTOM ? (
              <AdBanner advertisementData={advertisementData} />
            ) : (
              <AdBanner
                dataAdSlot={
                  block?.adType === "vertical"
                    ? "6237932871"
                    : block?.adType === "horizontal"
                    ? "6420662056"
                    : "5574484243"
                }
              />
            )
          ) : block?.adType === "horizontal" ? (
            <img
              src={block?.adType === "horizontal" ? "/images/temp/thumbnailHorizontal.png" : ""}
              alt="ad"
              className={`object-contain w-full ${block?.adType === "horizontal" ? "h-full" : ""}`}
            />
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
}
